export default __webpack_public_path__ + "08813bb4d83d6e8f00ca4a078dc1fcf7.svg";